import { api } from '@/api/api';
import { ContactSearchTransform } from '../contact_search_transform';
import ContactUtilInterface from '../contact_util';
import { transEnterpriseItemToContact as enterpriseTransEnterpriseItemToContact, transEnterpriseListToContact as enterpriseTransEnterpriseListToContact, transEnterpriseItem2ContactItem as enterpriseTransEnterpriseItem2ContactItem, transEnterpriseListToContactItem as enterpriseTransEnterpriseListToContactItem, transEnterprise2OrgContact as enterpriseTransEnterprise2OrgContact, transEnterpriseListToOrgContact as enterpriseTransEnterpriseListToOrgContact, transferEnterprise2MutileTableData as enterpriseTransferEnterprise2MutileTableData, } from '../transform/enterprise';
import { getContactLabel as commonGetContactLabel, getContactPYLabel as commonGetContactPYLabel, getFlatStrOrArrInfo as commonGetFlatStrOrArrInfo, transformContactModel as commonTransformContactModel, transExclude2FilterCondition as commonTransExclude2FilterCondition, transInclude2FilterCondition as commonTransInclude2FilterCondition, } from '../transform/common';
import { createCustomerId as customerCreateCustomerId, createCustomerOrgId as customerCreateCustomerOrgId, getCustomerContactIdList as customerGetCustomerContactIdList, getCustomerManagerIdList as customerGetCustomerManagerIdList, transClueToContact as customerTransClueToContact, transClueToOrg as customerTransClueToOrg, transClueToOrgManager as customerTransClueToOrgManager, transColleagueToUnitContact as customerTransColleagueToUnitContact, transCustomerRole2EmailRole as customerTransCustomerRole2EmailRole, transCustomerToContactModel as customerTransCustomerToContactModel, transCustomerToOrg as customerTransCustomerToOrg, transCustomerToOrgLabel as customerTransCustomerToOrgLabel, transCustomerToOrgManager as customerTransCustomerToOrgManager, transEmailRole2CustomerRole as customerTransEmailRole2CustomerRole, transLocal2ServerCustomerId as customerTransLocal2ServerCustomerId, transServerRepToDB as customerTransServerRepToDB, transToContact as customerTransToContact, transToLabel as customerTransToLabel, } from '../transform/customer';
import { transTeamToOrg as teamTransTeamToOrg, transServerTeamList as teamTransServerTeamList, transServerTeamMemberList as teamTransServerTeamMemberList, } from '../transform/team';
import { transContactModel2ContactSearch as searchTransContactModel2ContactSearch, transEdmContact2EdmContactSearch as searchTransEdmContact2EdmContactSearch, transEdmOrg2EdmOrgSearch as searchTransEdmOrg2EdmOrgSearch, transOrg2OrgSearch as searchTransOrg2OrgSearch, transServerSearch as searchTransServerSearch, } from '../transform/search';
import { buildContactItem as orgBuildContactItem, getPositionByUnit as orgGetPositionByUnit, transOrg2EntityOrg as orgTransOrg2EntityOrg, transformOrgData as orgTransformOrgData, } from '../transform/org';
import { compareServerAndLocalOrg as coreCompareServerAndLocalOrg, flattenServerUnit2FullOrgPath as coreFlattenServerUnit2FullOrgPath, lookupOrgFullPath as coreLookupOrgFullPath, transformCoreContact2MultipeData as coreTransformCoreContact2MultipeData, } from '../transform/core';
import { transOrgIdByPersonalOrg as personalTransOrgIdByPersonalOrg, transPersonalListToContact as personalTransPersonalListToContact, transPersonalItem2ContactInfo as personalTransPersonalItem2ContactInfo, transPersonalListToContactInfo as personalTransPersonalListToContactInfo, transPersonalListToOrgContact as personalTransPersonalListToOrgContact, transPersonalContact2MutipleData as personalTransPersonalContact2MutipleData, transPersonal2Mark as personalTransPersonal2Mark, transferPersonalList2PersonalMark as personalTransferPersonalList2PersonalMark, transPersonalOrgContact as personalTransPersonalOrgContact, transPersonalGroup2EntityOrgList as personalTransPersonalGroup2EntityOrgList, transformPersonalParam2PersonalMarkEntityList as personalTransformPersonalParam2PersonalMarkEntityList, transfromPersonalMarkRawData as personalTransfromPersonalMarkRawData, } from '../transform/personal';
export class ContactTransform extends ContactSearchTransform {
    constructor() {
        super(...arguments);
        this.systemApi = api.getSystemApi();
        this.contactUtil = ContactUtilInterface;
        this.transEnterprise2OrgContact = (item, _lastUpdateTime) => {
            return enterpriseTransEnterprise2OrgContact(item, _lastUpdateTime);
        };
    }
    transOrgIdByPersonalOrg(id) {
        return personalTransOrgIdByPersonalOrg(id);
    }
    transPersonalListToContact(list, _lastUpdateTime = Date.now()) {
        return personalTransPersonalListToContact(list, _lastUpdateTime);
    }
    transPersonalItem2ContactInfo(item, _lastUpdateTime) {
        return personalTransPersonalItem2ContactInfo(item, _lastUpdateTime);
    }
    transPersonalListToContactInfo(list, _lastUpdateTime = Date.now()) {
        return personalTransPersonalListToContactInfo(list, _lastUpdateTime);
    }
    transPersonalContact2MutipleData(list, _lastUpdateTime) {
        return personalTransPersonalContact2MutipleData(list, _lastUpdateTime);
    }
    transEnterpriseItemToContact(item, _lastUpdateTime, options) {
        return enterpriseTransEnterpriseItemToContact(item, _lastUpdateTime, {
            _account: options._account,
            currentCompanyId: options.currentCompanyId,
            contactUtil: this.contactUtil,
        });
    }
    transEnterpriseListToContact(list, _lastUpdateTime = Date.now(), options) {
        return enterpriseTransEnterpriseListToContact(list, _lastUpdateTime, {
            _account: options._account,
            contactUtil: this.contactUtil,
        });
    }
    transEnterpriseItem2ContactItem(item, _lastUpdateTime = Date.now(), force = false) {
        return enterpriseTransEnterpriseItem2ContactItem(item, _lastUpdateTime, force);
    }
    transEnterpriseListToContactItem(list, _lastUpdateTime = Date.now()) {
        return enterpriseTransEnterpriseListToContactItem(list, _lastUpdateTime);
    }
    transPersonalListToOrgContact(list, _lastUpdateTime = Date.now()) {
        return personalTransPersonalListToOrgContact(list, _lastUpdateTime);
    }
    transEnterpriseListToOrgContact(list, _lastUpdateTime = Date.now()) {
        return enterpriseTransEnterpriseListToOrgContact(list, _lastUpdateTime);
    }
    transferEnterprise2MutileTableData(list, lastUpdateTime, options) {
        return enterpriseTransferEnterprise2MutileTableData(list, lastUpdateTime, {
            force: options.force,
            unitPathMap: options.unitPathMap,
            _account: options._account,
            contactUtil: this.contactUtil,
        });
    }
    transPersonal2Mark(item, _lastUpdateTime, type = 1) {
        return personalTransPersonal2Mark(item, _lastUpdateTime, type);
    }
    transferPersonalList2PersonalMark(list, type = 1, _lastUpdateTime = Date.now()) {
        return personalTransferPersonalList2PersonalMark(list, type, _lastUpdateTime);
    }
    transTeamToOrg(list) {
        return teamTransTeamToOrg(list);
    }
    transServerTeamMemberList(item) {
        return teamTransServerTeamMemberList(item);
    }
    transServerTeamList(list) {
        return teamTransServerTeamList(list);
    }
    transServerRepToDB(data, type, lastUpdateTime) {
        return customerTransServerRepToDB(data, type, lastUpdateTime, { systemApi: this.systemApi });
    }
    transCustomerToOrg(item, _lastUpdateTime) {
        return customerTransCustomerToOrg(item, _lastUpdateTime, { systemApi: this.systemApi });
    }
    transClueToOrg(item, _lastUpdateTime) {
        return customerTransClueToOrg(item, _lastUpdateTime, { systemApi: this.systemApi });
    }
    transCustomerToOrgLabel(item, _lastUpdateTime) {
        return customerTransCustomerToOrgLabel(item, _lastUpdateTime, { systemApi: this.systemApi });
    }
    transCustomerToOrgManager(item, _lastUpdateTime) {
        return customerTransCustomerToOrgManager(item, _lastUpdateTime, { systemApi: this.systemApi });
    }
    transClueToOrgManager(item, _lastUpdateTime) {
        return customerTransClueToOrgManager(item, _lastUpdateTime, { systemApi: this.systemApi });
    }
    transToContact(data, type, _lastUpdateTime) {
        return customerTransToContact(data, type, _lastUpdateTime, { systemApi: this.systemApi });
    }
    getCustomerContactIdList(data, type) {
        return customerGetCustomerContactIdList(data, type);
    }
    getCustomerManagerIdList(data, type) {
        return customerGetCustomerManagerIdList(data, type);
    }
    transToLabel(label, parentId, customerType, _lastUpdateTime) {
        return customerTransToLabel(label, parentId, customerType, _lastUpdateTime, { systemApi: this.systemApi });
    }
    transClueToContact(item) {
        return customerTransClueToContact(item);
    }
    transColleagueToUnitContact(item, _lastUpdateTime) {
        return customerTransColleagueToUnitContact(item, _lastUpdateTime);
    }
    getContactLabel(name) {
        return commonGetContactLabel(name);
    }
    getContactPYLabel(name) {
        return commonGetContactPYLabel(name);
    }
    transLocal2ServerCustomerId(id) {
        return customerTransLocal2ServerCustomerId(id);
    }
    createCustomerId(id) {
        return customerCreateCustomerId(id);
    }
    createCustomerOrgId(data, type) {
        return customerCreateCustomerOrgId(data, type);
    }
    buildContactItem(params) {
        return orgBuildContactItem(params);
    }
    transCustomerToContactModel(item) {
        return customerTransCustomerToContactModel(item);
    }
    getFlatStrOrArrInfo(arr, type, rs) {
        return commonGetFlatStrOrArrInfo(arr, type, rs);
    }
    transPersonalOrgContact(list, orgIdList) {
        return personalTransPersonalOrgContact(list, orgIdList);
    }
    transformOrgData(config) {
        return orgTransformOrgData(Object.assign(Object.assign({}, config), { contactUtil: this.contactUtil }));
    }
    transformContactModel(data) {
        return commonTransformContactModel(data);
    }
    transExclude2FilterCondition(exclude, item) {
        return commonTransExclude2FilterCondition(exclude, item);
    }
    transInclude2FilterCondition(include, item) {
        return commonTransInclude2FilterCondition(include, item);
    }
    getPositionByUnit(orgId) {
        return orgGetPositionByUnit(orgId);
    }
    transServerSearch(list) {
        return searchTransServerSearch(list);
    }
    transContactModel2ContactSearch(list) {
        return searchTransContactModel2ContactSearch(list);
    }
    transOrg2OrgSearch(list) {
        return searchTransOrg2OrgSearch(list);
    }
    transEdmContact2EdmContactSearch(list) {
        return searchTransEdmContact2EdmContactSearch(list);
    }
    transEdmOrg2EdmOrgSearch(list) {
        return searchTransEdmOrg2EdmOrgSearch(list);
    }
    transCustomerRole2EmailRole(type, role) {
        return customerTransCustomerRole2EmailRole(type, role);
    }
    transEmailRole2CustomerRole(role) {
        return customerTransEmailRole2CustomerRole(role);
    }
    transfromPersonalMarkRawData(rawDataList) {
        return personalTransfromPersonalMarkRawData(rawDataList);
    }
    transformPersonalParam2PersonalMarkEntityList(model) {
        return personalTransformPersonalParam2PersonalMarkEntityList(model);
    }
    transOrg2EntityOrg(params) {
        return orgTransOrg2EntityOrg(Object.assign(Object.assign({}, params), { contactUtil: this.contactUtil }));
    }
    transPersonalGroup2EntityOrgList(list, _lastUpdateTime) {
        return personalTransPersonalGroup2EntityOrgList(list, _lastUpdateTime);
    }
    transformCoreContact2MultipeData(modeList, fullUnitPathlist, options) {
        return coreTransformCoreContact2MultipeData(modeList, fullUnitPathlist, Object.assign(Object.assign({}, options), { contactUtil: this.contactUtil }));
    }
    lookupOrgFullPath(options) {
        return coreLookupOrgFullPath(options);
    }
    flattenServerUnit2FullOrgPath(rawData, options, _companyId) {
        return coreFlattenServerUnit2FullOrgPath(rawData, Object.assign(Object.assign({}, options), { contactUtil: this.contactUtil }), _companyId);
    }
    compareServerAndLocalOrg(serverOrgList, localOrgList) {
        return coreCompareServerAndLocalOrg(serverOrgList, localOrgList);
    }
    uniqueServerContactListByEmails(emailList, contactList) {
        if (!contactList.length || !emailList.length) {
            return contactList;
        }
        const res = new Map();
        contactList.forEach(model => {
            const email = this.contactUtil.doGetModelDisplayEmail(model);
            if (res.has(email)) {
                const oldModel = res.get(email);
                res.set(email, this.contactUtil.getValidModel(oldModel, model));
            }
            else {
                res.set(email, model);
            }
        });
        return [...res.values()];
    }
}
export const ContactTransformInstance = new ContactTransform();
